import { ImpexChildSettingsModel } from '@y42/impex';
import { DatasourceTableSettings, StitchColumnPropertiesModel } from '@y42/json-schema';
import type { DatasourceTableStoreModel } from './datasource-table.model';

export type Y42WriteSettings = Exclude<DatasourceTableSettings['_datos_write_settings'], undefined>;

export interface DatasourceTableSettingsBase
  extends ImpexChildSettingsModel,
    Pick<DatasourceTableSettings, '_datos_write_settings' | 'csv_options'> {}

export interface IDatasourceTableSettingsDatasetModel
  extends DatasourceTableSettingsBase,
    Required<Pick<DatasourceTableSettings, 'table_id'>> {}

export interface DatasourceTableSettingsAirByteProperties
  extends Pick<
    DatasourceTableSettings,
    'supported_sync_modes' | 'source_defined_cursor' | 'default_cursor_field' | 'source_defined_primary_key'
  > {}
export interface DatasourceTableStitchSettingsModel
  extends DatasourceTableSettingsBase,
    Required<Pick<DatasourceTableSettings, 'import' | 'columns'>>,
    Pick<DatasourceTableSettings, 'key_properties' | 'group'> {
  schema: {
    $schema: string;
    type: string;
    properties: Record<string, StitchColumnPropertiesModel>;
  };
}

export interface TableSettingsUploadModel
  extends DatasourceTableSettingsBase,
    Required<Pick<DatasourceTableSettings, 'content-type' | 'uploadTarget' | 'originalName' | 'size' | 'uri'>>,
    Pick<DatasourceTableSettings, 'reupload'> {}

export interface DatasourceTableGoogleSheetsSettingModel
  extends DatasourceTableSettingsBase,
    Required<Pick<DatasourceTableSettings, 'sheet_id' | 'mime_type'>> {}

export type AllDatasourceTableSettingsModel =
  | DatasourceTableStitchSettingsModel
  | TableSettingsUploadModel
  | DatasourceTableGoogleSheetsSettingModel
  | IDatasourceTableSettingsDatasetModel;

export class DatasourceTableSettingsGitModel
  extends DatasourceTableSettings
  implements
    DatasourceTableSettingsBase,
    Partial<IDatasourceTableSettingsDatasetModel>,
    Partial<DatasourceTableStitchSettingsModel>,
    Partial<TableSettingsUploadModel>,
    Partial<DatasourceTableGoogleSheetsSettingModel>,
    DatasourceTableSettingsAirByteProperties
{
  constructor(model: DatasourceTableStoreModel) {
    super();
    const settings = model.settings!;

    this.$schema = settings.$schema;
    this.columns = settings.columns;
    this.import = settings.import;
    this.key_properties = settings.key_properties;
    this['content-type'] = settings['content-type'];
    this.uploadTarget = settings.uploadTarget;
    this.originalName = settings.originalName;
    this.size = settings.size;
    this.uri = settings.uri;
    this.reupload = settings.reupload;
    this.sheet_id = settings.sheet_id;
    this.mime_type = settings.mime_type;
    this.table_id = settings.table_id;
    this._datos_write_settings = settings._datos_write_settings;
    this.csv_options = settings.csv_options;
    this.output_key = settings.output_key;
    this.schema = settings.schema;
    this.group = settings.group;

    // Airbyte incremental imports related fields
    this.supported_sync_modes = settings.supported_sync_modes;
    this.source_defined_cursor = settings.source_defined_cursor;
    this.default_cursor_field = settings.default_cursor_field;
    this.source_defined_primary_key = settings.source_defined_primary_key;
  }

  schema?: {
    $schema: string;
    type: string;
    properties: Record<string, StitchColumnPropertiesModel>;
  };
  /**
   * DO NOT MODIFY ANY PROPERTIES HERE.
   * TO LEARN HOW TO MODIFY CLASSES GENERATED FROM JSON-SCHEMA
   * TAKE A LOOK AT https://y42-com.slab.com/posts/working-with-json-schemas-1hz2gcvj
   */
}
